import Link from './link.component'
import { Appearance, Size } from './link.component'

export { Appearance, Size }
export default Link
